module.exports = __webpack_public_path__ + "static/media/office-lunch-catering-1.badd5de4.jpg";